// Renders a generated HTML media (docs/09 §B) in a sandboxed iframe. Fetches the
// document from GET /v1/media/:id/file and injects it via `srcDoc` rather than
// pointing `iframe.src` at the URL: an iframe *navigation* isn't intercepted by the
// MSW demo service worker (only subresource fetches are), and `srcDoc` also keeps
// the frame in a null-origin sandbox regardless of where the API is hosted. The
// document runs with `sandbox="allow-scripts"` — scripts, but no same-origin, no
// network, no access to the CMS origin.

import { useEffect, useState } from 'react';
import { mediaFileUrl } from '../api/media.ts';
import { ScaledFrame } from './ScaledFrame.tsx';

export function SandboxedHtmlFrame({
  mediaId,
  title,
  className,
}: {
  mediaId: string;
  title: string;
  className?: string;
}) {
  const [html, setHtml] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    setHtml(null);
    fetch(mediaFileUrl(mediaId), { credentials: 'include', signal: controller.signal })
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error('load failed'))))
      .then(setHtml)
      .catch(() => {
        /* best-effort preview — a failed load just leaves the frame blank */
      });
    return () => controller.abort();
  }, [mediaId]);

  return (
    <ScaledFrame
      title={title}
      className={className}
      referrerPolicy="no-referrer"
      srcDoc={html ?? ''}
    />
  );
}
